/* WebComponentUserIcon component */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging -- disabled to allow to inherit from AbstractComponent */
import { Component, Element, h, Listen, Prop, State } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import UserIconTemplate from './cwc-user-icon.template';
import { AbstractComponent } from '@cewe-designsystem/abstract';
import '@cewe-designsystem/component_modal';
import packageInfo from '../package.json';

@Component({
  tag: 'cwc-user-icon',
  styleUrl: './cwc-user-icon.scss',
  shadow: true,
})
export class UserIconComponent {
  @Element() element: HTMLElement;

  @Prop() operator: number;
  @Prop() keyAccount: number;
  @Prop() enableModal: boolean;
  @Prop() myAccountLink: string;
  @Prop() textLoggedIn: string;

  @State()
  private loggedIn: boolean = false;

  @State()
  private showModal: boolean = false;

  @Listen('login-info-update', { target: 'window' })
  listenToEvent(event: CustomEvent) {
    this.loggedIn = event.detail.loggedIn;
  }

  componentWillLoad() {
    if (!this.myAccountLink) {
      this.myAccountLink = window.location.origin + '/account.html#/auth';
    }

    this.setLoggedInState();
    document.querySelector('cwc-user-icon')?.setAttribute('version', packageInfo.version);
  }

  componentDidLoad() {
    const nativeElement = this.element.shadowRoot.getElementById('user-icon-modal');
    nativeElement.addEventListener('on:modal:close', () => {
      this.closeModal();
    });
  }

  onIconClicked() {
    if (this.enableModal) {
      this.showModal = true;
    } else {
      this.goToLogin(false);
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onIconClicked();
    }
  }

  closeModal() {
    this.showModal = false;
  }

  logout() {
    const logoutEndpointCapi = '/capi/bff/' + this.keyAccount + '/secured/logout?ts=' + Date.now();
    const logoutEndpointIPS = '/web/' + this.operator + '/logout.do';
    fetch(logoutEndpointCapi).then(() => {
      fetch(logoutEndpointIPS).then(() => {
        // this is necessary since this action is only executed in checkout.html
        document.cookie = this.keyAccount + '_session_cart;expires=0;';
        localStorage.removeItem('co.' + this.keyAccount + '.CART_INFO');
        localStorage.removeItem('opsSession');

        window.location.reload();
      });
    });
  }

  goToLogin(goToReturnUrl: boolean = false) {
    // this will lead to my account if the user is already logged in
    if (this.showModal && goToReturnUrl) {
      window.location.href = this.myAccountLink + '?returnURL=' + encodeURIComponent(window.location.href);
      this.closeModal();
    } else {
      window.location.href = this.myAccountLink;
    }
  }

  private setLoggedInState() {
    if (this.keyAccount) {
      const capiEndpoint = '/capi/bff/' + this.keyAccount + '/auth/session/info';
      fetch(capiEndpoint, {
        headers: {
          'ui-version': 'ui' + packageInfo.version,
        },
      })
        .then((res) => res.json())
        .then((userInfo: CapiUserInfo) => {
          this.loggedIn = !!userInfo.user;
        });
    }
  }

  render() {
    return (
      <UserIconTemplate
        controller={this}
        version={packageInfo.version}
        loggedIn={this.loggedIn}
        showModal={this.showModal}
        textLoggedIn={this.textLoggedIn}
      />
    );
  }
}

Object.setPrototypeOf(UserIconComponent.prototype, AbstractComponent.prototype);

export interface UserIconComponent extends AbstractComponent {}

interface CapiUserInfo {
  token: string;
  user?: {
    firstName: string;
    lastName: string;
  };
}
